export default "__VITE_PUBLIC_ASSET__34e40f89__"